/**
 * V1 borrower product catalog — exactly six products.
 * Display only; routing lives in triageRouter.js.
 */

export const V1_PRODUCT_IDS = {
  CONVENTIONAL_PURCHASE: 'conventional-purchase',
  FHA_PURCHASE: 'fha-purchase',
  FHA_STREAMLINE: 'fha-streamline',
  VA_IRRRL: 'va-irrrl',
  CONVENTIONAL_RATE_TERM: 'conventional-rate-term',
  CONVENTIONAL_CASH_OUT: 'conventional-cash-out',
};

export const V1_PRODUCTS = {
  [V1_PRODUCT_IDS.CONVENTIONAL_PURCHASE]: {
    id: V1_PRODUCT_IDS.CONVENTIONAL_PURCHASE,
    name: 'Conventional Purchase',
    shortDescription: 'Primary residence purchase with a conventional loan.',
    purpose: 'purchase',
  },
  [V1_PRODUCT_IDS.FHA_PURCHASE]: {
    id: V1_PRODUCT_IDS.FHA_PURCHASE,
    name: 'FHA Purchase',
    shortDescription: 'Primary residence purchase with FHA insurance.',
    purpose: 'purchase',
  },
  [V1_PRODUCT_IDS.FHA_STREAMLINE]: {
    id: V1_PRODUCT_IDS.FHA_STREAMLINE,
    name: 'FHA Streamline Refinance',
    shortDescription: 'Refinance an existing FHA loan with limited documentation.',
    purpose: 'refinance',
  },
  [V1_PRODUCT_IDS.VA_IRRRL]: {
    id: V1_PRODUCT_IDS.VA_IRRRL,
    name: 'VA IRRRL',
    shortDescription: 'Interest Rate Reduction Refinance Loan on an existing VA mortgage.',
    purpose: 'refinance',
  },
  [V1_PRODUCT_IDS.CONVENTIONAL_RATE_TERM]: {
    id: V1_PRODUCT_IDS.CONVENTIONAL_RATE_TERM,
    name: 'Conventional Rate/Term Refinance',
    shortDescription: 'Refinance to change rate, term, or payment without taking cash out.',
    purpose: 'refinance',
  },
  [V1_PRODUCT_IDS.CONVENTIONAL_CASH_OUT]: {
    id: V1_PRODUCT_IDS.CONVENTIONAL_CASH_OUT,
    name: 'Conventional Cash-Out Refinance',
    shortDescription: 'Refinance and take equity out as cash (primary residence).',
    purpose: 'refinance',
  },
};

export const getV1Product = (id) => V1_PRODUCTS[id] || null;

export const listV1Products = (ids) => ids.map((id) => V1_PRODUCTS[id]).filter(Boolean);
